import { Progress } from "@backstage/core-components";
import { Spacer } from "@internal/plugin-utilities";
import { Typography } from "@material-ui/core";
import React from "react";
import { VIOLATION_TABLE } from "@internal/plugin-ops-review-common";
import { TeamBreakdownHeader } from "../TeamBreakdownHeader";

interface Props {
  ownershipData: any;
  loading: boolean;
}

export const Ownership: React.FC<Props> = ({
  ownershipData,
  loading,
}: Props): JSX.Element => {
  if (loading || !ownershipData) {
    return <Progress />;
  }

  const reposInViolation = ownershipData.data
    .filter((own: any) => {
      return !own.hasCatalogInfo;
    })
    .map((own: any) => own.repo);

  return (
    <div>
      <TeamBreakdownHeader
        title={VIOLATION_TABLE.kajabi.missing_catalog_info.display}
        vendor="kajabi"
      />
      <Spacer variant="normal" />
      <Typography align="center">
        The following repositories have been identified as potentially being
        owned by {ownershipData.team}, however, they are missing a{" "}
        <code>catalog-info.yaml</code> document to register with Radiator:{" "}
        <br />
        <br />
        <code>{reposInViolation.join(", ")}</code>
      </Typography>
    </div>
  );
};
